module.exports = __webpack_public_path__ + "static/media/Happy4.73480916.svg";